import { render, staticRenderFns } from "./oldActivity.vue?vue&type=template&id=21637f42&scoped=true"
import script from "./oldActivity.vue?vue&type=script&lang=js"
export * from "./oldActivity.vue?vue&type=script&lang=js"
import style0 from "./oldActivity.vue?vue&type=style&index=0&id=21637f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21637f42",
  null
  
)

export default component.exports